const api={
    // httpUrl:"http://yunen.test.brjkj.cn:30000",        //测试环境
    // httpUrl:'https://pro.brjxf119.com/test/api',    //测试环境
    httpUrl:'https://pro.brjxf119.com/api',         //生产环境
  
    loGin:"/auth-service",            //登录的前缀
    Operate:"/operate-aggre-service", //运维平台的前缀
    IOT:"/device-api-service",        //IOT平台登录前缀 
    factory:'/factory-aggre-service', //工厂管理前缀
    bucketName:"brj-test"
}

const urlAddress = {  
     UPLOADINGAS:api.httpUrl+"/minio-service/minio/uploadSingle?bucketName=brj-test",              //上传图片单张
     UPLOADINGMO:api.httpUrl+"/minio-service/minio/uploadMultipleFile?bucketName=brj-test",        //上传图片多张
	 UPLOADAPK:api.httpUrl+"/operate-aggre-service/system/uploadApp",                              //上传apk
     SHOWIMG:"/minio-service/minio/preview",                                                            //预览图片(单张) 
     SHOWIMGMORE:"/minio-service/minio/previewBatch",                                                   //预览图片(多张) 
}

//登录
const LOGIN = {
    LOGIN:api.loGin+'/auth/login',     //登录 
    OUTLOGIN:api.loGin+"/auth/logOut", //退出登录
    PWDXIUGAI:api.Operate+'/userManage/resetPwdByCode',               //更改Miami
    SENDCODE:'/engineer-applet-service/common/sendCode',             //发送验证码
}

//运维平台
const OPERATE = {  

    PERSONALMESS:api.Operate+"/personalCenter/getPersonCenterInfo",  //个人信息--个人信息
    PERSONALPWORUPDATA:api.Operate+"/personalCenter/updatePwd",      //个人信息--修改密码      
    LEFTNAV:api.Operate+"/overview/getMenuButtonByUserId",           //左侧导航栏
   
    //接口域名模块
    JIEKOULIST:api.Operate+"/power/getPowerTree",             //接口域名模块--接口列表  
    JIEKOUADD:api.Operate+"/power/add",                       //接口域名模块--新增接口
    JIEKOUDELETE:api.Operate+"/power/delete",                 //接口域名模块--删除接口      
    JIEKOUDUPDATE:api.Operate+"/power/update",                //接口域名模块--编辑接口 
    //系统设置
    SYSTEMLIST:api.Operate+"/system/systemPage",             //系统设置--系统参数列表
    SYSTEMADD:api.Operate+"/system/addSystem",               //系统设置--新增系统参数
    SYSTEMDELETE:api.Operate+"/system/deleteSystem",         //系统设置--删除系统参数
    SYSTEMUPDATE:api.Operate+"/system/updateSystem",         //系统设置--修改系统参数

    SYSTEMTAOCANLIST:api.IOT+"/setMealMange/getDeviceSetMealPage",    //系统设置--设备服务--套餐列表
    SYSTEMTAOCANADD:api.IOT+"/setMealMange/addDeviceSetMeal",         //系统设置--设备服务--添加套餐
    SYSTEMTAOCANDELETE:api.IOT+'/setMealMange/deleteDeviceSetMeal',   //系统设置--设备服务--删除套餐
    SYSTEMTAOCANEIDT:api.IOT+'/setMealMange/updateDeviceSetMeal',     //系统设置--设备服务--编辑套餐
    SYSTEMTAOCANDXVOILIST:api.IOT+'/setMealMange/getSvSetMealPage',   //系统设置--短信语音--套餐列表
    SYSTEMTAOCANDXVOIADD:api.IOT+'/setMealMange/addSvSetMeal',        //系统设置--短信语音--套餐增加
    SYSTEMTAOCANDXVOIEIDT:api.IOT+'/setMealMange/updateSvSetMeal',    //系统设置--短信语音--套餐修改
    SYSTEMTAOCANDXVOIDELETE:api.IOT+'/setMealMange/deleteSvSetMeal',  //系统设置--短信语音--套餐删除
    
    //报警管理
    BAOJINGADD:api.IOT+"/policeConfigMange/addPoliceConfig",           //报警管理-报警新增
    BAOJINGDELETE:api.IOT+"/policeConfigMange/deletePoliceConfig",     //报警管理-报警删除
    BAOJINGDETAILS:api.IOT+"/policeConfigMange/getPoliceConfigDetails",//报警管理-报警详情信息
    BAOJINGSETLIST:api.IOT+"/policeConfigMange/getPoliceConfigPage",   //报警管理-报警设置列表
    BAOJINGSETMODIFY:api.IOT+"/policeConfigMange/updatePoliceConfig",  //报警管理-报警修改


    BAOJINGMOBANLIST:api.IOT+'/pushTemplateMange/getPushTemplateList', //报警管理-模版列表
    BAOJINGMOBANADD:api.IOT+'/pushTemplateMange/addPushTemplate',      //报警管理-模版添加
    BAOJINGMOBANDELETE:api.IOT+'/pushTemplateMange/deletePushTemplate',//报警管理-模版删除
    BAOJINGMOBANEIDT:api.IOT+'/pushTemplateMange/updatePushTemplate',  //报警管理-模版编辑
    BAOJINGTYPELIST:api.IOT+'/policeType/list',       //报警管理-报警类型列表
    BAOJINGTYPEADD:api.IOT+'/policeType/save',        //报警管理-报警类型新增
    BAOJINGTYPEEIDT:api.IOT+'/policeType/update',     //报警管理-报警类型编辑
    BAOJINGTYPEDELETE:api.IOT+'/policeType/delete',   //报警管理-报警类型删除

    GETDEVICEPOLICEPAGE:api.Operate+'/policeManager/getDevicePolicePage', // 报警报警记录
    GETDEVICETYPETREE:api.Operate+'/product/deviceType',  // 获取设备类型树

    //模块管理
    MODULElIST:api.Operate+"/model/getSubsystemList",         //模块管理-初始话平台
    MODULEUPDATA:api.Operate+"/model/updateSubsystem",        //模块管理-修改平台
    MODULETREE:api.Operate+"/model/getMenuButtonTree",        //模块管理-平台的菜单列表
    MODULEADD:api.Operate+"/model/addMenuButton",             //模块管理-新增平台菜单
    MODULEDELETE:api.Operate+"/model/deleteMenuButton",       //模块管理-删除平台菜单
    MODULEUPDATE:api.Operate+"/model/updateMenuButton",       //模块管理-修改平台菜单
    MODULEHUIXIAN:api.Operate+"/model/getButtonByMenuId",     //模块管理-查询按钮回显的接口
    MODULEHUIEMEN:api.Operate+"/model/getPowerIdsByMb",       //模块管理-查询菜单回显的接口
    BTNMENULADD:api.Operate+"/model/addBatchMenuButton",      //模块管理-菜单按钮批量新增
    BTNMENULUPDATE:api.Operate+"/model/updateBatchMenuButton",//模块管理-菜单按钮批量更新

    GETPLATFORMUSER:api.Operate+'/userManage/getPlatformUsers',  // 获取代理商工厂工程商的机构 2 工厂 3 代理商 4 工程商

    //数据字典- 
    DICTIONARYTYPELIST:api.Operate+"/dictionary/getDisctTypeList",  //数据字典--字典左侧的数据类型列表
    DICTIONARYTYPEADD:api.Operate+"/dictionary/addDictType",        //数据字典--字典左侧的数据类型新增
    DICTIONARYTYPEUPDATE:api.Operate+"/dictionary/updateDictType",  //数据字典--字典左侧的数据类型修改
    DICTIONARYTLIST:api.Operate+"/dictionary/page",                 //数据字典--字典数据列表
    DICTIONARYTREE:api.Operate+"/dictionary/dictTree",              //数据字典--树形结构
    DICTIONARYTADD:api.Operate+"/dictionary/addDict",               //数据字典--字典数据新增
    DICTIONARYTUPDATA:api.Operate+"/dictionary/updateDict",         //数据字典--字典数据编辑

    //产品管理
    PRODUCTJINKONG:api.Operate+"/deviceManager/getDeviceDetailPage", //产品管理--设备监控
    PRODUCTLIST:api.Operate+"/product/page",                         //产品管理--企业产品信息列表  
    PRODUCTTYPELIST:api.Operate+'/product/deviceType',               //产品管理--产品分类
    PRODUCTDETAIL:api.Operate+"/product/detail",                     //产品管理--产品详情             
    PRODUCTCOMMY:api.Operate+"/product/getPageByFactoryId",          //产品管理--企业产品详情 
    PRODUCTFACTORYINFO:api.Operate+"/product/factoryInfo/",          //产品管理--工厂信息
    PRODUCTIMEILIST:api.Operate+"/product/deviceInstallList",        //产品管理--待安装及其为安装的设备列表

  
    // 项目管理
    GETPROJECTLIST:api.Operate+"/project/getProjectLists",         //项目管理查询
    EXPORTPROJECT:api.Operate+"/project/exportProject",            //导出项目
    DELPROJECT:api.Operate+"/project/delete",                      //删除项目
    GETSTUCTURE:api.Operate+'/project/getStructure',               //获取空间区域
    SPACESTRUCTURE:api.Operate+'/project/spaceStructure',          //获取施工图
    GETPROJECTMEMBER:api.Operate + '/project/getProjectMemberList',//获取成员列表
    EXPORTPROMEMBER:api.Operate+'/project/exportProjectMember',    //导出项目成员
    GETDEVICELIST:api.Operate+'/project/pageDeviceByProject',      //设备列表
    EXPORTDEV:api.Operate+'/project/exportDevice',                 //导出项目设备
    GETPOLICELIST:api.Operate+'/project/pageDevicePolice',         //获取报警列表
    EXPORTPOLICE:api.Operate+'/project/exportDevicePolice',        //导出报警记录
    GETDEVLINKAGEPAGE:api.Operate+'/project/getDeviceLinkagePage', //设备联动查询
    EXPROTLINKAGE:api.Operate+'/project/exportDeviceLinkage',      //导出设备联动
    GETDEVSUBLIST:api.Operate+'/project/getDeviceLinkageSubList',  //获取项目联动信息
    PROFITLIST:api.Operate+"/project/getTransferConfigPage",       //分润项目
    PROFITSELECT:api.Operate+"/project/getDropDownList",           //分瑞项目下拉
    UPDATECFI:api.Operate+"/project/updateTransferConfig",         //更新配置
    FENRUIJILU:api.Operate+"/project/getShareRecordPlatformPage",  //分润记录 


    // 公告管理
    GETADCONSULTPAGE:api.Operate+'/adConsultManager/getAdConsultPage',                  // 获取公告管理列表
    GETAGENTPAGE:api.Operate+'/adConsultManager/getAgentPage',                          // 获取所有代理商
    GETENGINEERPAGE:api.Operate+'/adConsultManager/getEngineerPage',                    // 获取所有工程商
    GETFACTORYPAGE:api.Operate+'/adConsultManager/getFactoryPage',                      // 获取所有工厂
    GETOPERATEPAGE:api.Operate+'/adConsultManager/getOperatePage',                      // 获取所有运营
    INSERTADCONSULT:api.Operate+'/adConsultManager/insertAdConsult',                    // 新增公告
    UPDATEBYADCONSULTID:api.Operate+'/adConsultManager/updateByAdConsultId',            // 发布公告
    DELADCONSULTID:api.Operate+'/adConsultManager/delByAdConsultId',                    // 删除公告
    GETADCONSULTBYID:api.Operate+'/adConsultManager/getAdConsultById',                  // 查询公告
    CANCECONSULT:api.Operate+'/adConsultManager/cancelAdConsult',                       // 取消公告

    // banner管理
    GETBANNERDETAILSLIST:api.Operate+'/bannerManager/getBannerDetailsList',          // 获取banner分页
    GETBANNERLAYOUTLIST:api.Operate+'/bannerManager/getBannerLayoutList',            // 获取所有的banner类型
    UPDATEBANNERDETAILS:api.Operate+'/bannerManager/updateBannerDetails',            // 编辑Banner图
    DELETEBANNERDETAILS:api.Operate+'/bannerManager/deleteBannerDetails',            // 删除Banner图
    ADDBANNERDETAILS:api.Operate+'/bannerManager/addBannerDetails', 

    //平台概况
    PROJECTUSER:api.Operate+"/overview/accumulatedStatistics",                          //设备总数
    USERADDCHART:api.Operate+"/overview/getUserOverview",                               //用户概况 
    EQBAOJINGLIST:api.Operate+"/overview/getDevicePoliceOverview",                      //设备报警情况
    EQBAOJINGCHULI:api.Operate+"/overview/getProcessedPoliceOverview",                  //设备报警已处理

    PROJECTMAP:api.Operate+"/overview/projectDistribution",                             //项目分布
    FCLASSPROPORTION:api.Operate+"/overview/factoryClassProportion",                    //工厂分类占比 工厂类型 工厂数
    ECLASSPROPORTION:api.Operate+"/overview/equipmentClassProportion",                  //设备分类占比 地区 项目数

    //财务管理

    FACCOUNT:api.Operate+"/financeManager/getFinancialLedger",                          //财务台账
    GETPAGEACCOUNT:api.Operate+"/financeManager/getPageAccount",                        //财务台账-充值记录
    VOICEXUFEI:api.Operate+"/financeManager/getFinancialLedgerBySmsAndVoice",           //财务台账-语音短信消费记录
    GETPAGEACCOUNTDE:api.Operate+"/financeManager/getAccountRechargeRecordPage",        //账户充值记录分页查询
    INCOMEMONEY:api.Operate+"/financeManager/getPlatformByIncome",                      //平台收入 
    INCOMEMONEYPING:api.Operate+"/financeManager/getPieByIncome",                       //平台收入饼图
    INCOMEMONEYZHU:api.Operate+"/financeManager/getHistogramByIncome",                  //平台收入柱状图
    ZHICHU:api.Operate+"/financeManager/getPlatformByPay",                              //平台支出
    ZHICHUBING:api.Operate+"/financeManager/getPieByPay",                               //平台支出饼图
    ZHUCHUZHU:api.Operate+"/financeManager/getHistogramByPay",                          //平台支出柱状图 
    CHONGZHIJILU:api.Operate+"/financeManager/getRechargeRecordPage",                   //充值记录
    FUWUFEIJILI:api.Operate+"/financeManager/getDeviceConsumePage",                     //服务费充值记录
    EXPORTBEN:api.Operate+"/financeManager/exportRechargeRecord",                       //导出充值记录
    EXPORSEVER:api.Operate+"/financeManager/exportDeviceConsume",                       //导出服务费记录
	
    //日志管理
    LOGLIST:api.Operate+"/systemLog/getSystemPublishEventPage",                         //操作日志管理
    LOGAPP:api.Operate+"/systemLog/getExceptionAppLogPage",                             //APP日志

	//意见反馈
	PROBLEMLIST:api.Operate+"/feedback/selectCommonProblemPage",                     //问题列表
	INSERTPROBLEM:api.Operate+"/feedback/insertCommonProblem",                       //新增问题
	DELATEPROBLE:api.Operate+"/feedback/delCommonProblemByCommId",                   //删除问题
	UPDATEPROBLE:api.Operate+"/feedback/updateCommonProblemByCommId",                //修改问题
	DEALWITHLIST:api.Operate+"/feedback/selectSuggestPage",                          //反馈意见列表
	UPDATESUGGEST:api.Operate+"/feedback/updateBySuggestId",                         //修改反馈与意见
	INSERTSUGGEST:api.Operate+"/feedback/insertSuggest",                             //插入新增意
	EXPORTSUGGSE:api.Operate+"/feedback/exportSuggestList",                          //导出反馈意见列表
	
	//app版本管理
	APPLIST:api.Operate+"/system/getAppReleases",                                      //app列表
	INSERTAPP:api.Operate+"/system/saveAppRelease",                                    //新增app版本
	UPDATEAPP:api.Operate+"/system/updateAppRelease",                                  //修改app版本
	
} 

//用户平台
const USERAPI={
    //用户管理
    USERLIST:api.Operate+"/userManage/userPage",                 //用户管理-内部用户
    USERDELETE:api.Operate+"/userManage/deleteUser/",            //用户管理-内部用户删除
    USERUPDATE:api.Operate+"/userManage/updateUserAble",         //用户管理-内部用启用禁用
    USERUPADD:api.Operate+"/userManage/addUser",                 //用户管理-内部新增
    USERUPUPDATE:api.Operate+"/userManage/updateUser",           //用户管理-内部用户更新
    USERUFACTORY:api.Operate+"/userManage/getFactoryUserPage",   //用户管理-工厂用户
    USERUAGENTUSER:api.Operate+"/userManage/getAgentUserPage",   //用户管理-代理商用户
    USERUCOMPAN:api.Operate+"/userManage/getEngineerUserPage",   //用户管理-工程商用户
    USERTERRACE:api.Operate+"/userManage/getPersonUserPage",     //用户管理-个人用户

    //工厂管理
    FACTORYLIST:api.Operate+"/factory/page",                     //工厂管理-工厂列表
    FACTORYUPDATE:api.Operate+"/factory/update",                 //工厂管理-更新工厂
    FACTORYDELETE:api.Operate+"/factory/delete",                 //工厂管理-删除工厂  
    FACTORYADD:api.Operate+"/factory/add",                       //工厂管理-新增工厂
    FACTROYTYPELISTX:api.Operate+"/model/getFactoryTypes",       //工厂管理-工厂的类型的列表新增工厂的时候使用
    FACTROYTYPEMENU:api.Operate+"/model/getMBTreeByFtId",        //工厂管理-选择工厂时候的显示菜单
    FACTROYDEVETYP:api.IOT+"/deviceTypeManage/deviceTypeTree",   //工厂管理-下拉生产设备类型
    FACTORYGETTYPE:api.Operate+"/factory/getFactoryDetails",     //工厂管理-更新工厂的生产设备类型回显
    FACTORYRESTPOSSWORD:api.Operate+"/factory/reset/password",   //工厂管理-重置工厂登录密码
    

    //工厂类型
    FACTORYTYPELIST:api.Operate+"/model/getFactoryTypePage",   //工厂类型-工厂类型列表
    FACTORYTYPEADD:api.Operate+"/model/addFactoryType",        //工厂类型-工厂类型新增
    FACTORYTYPEUPDATE:api.Operate+"/model/updateFactoryType",  //工厂类型-工厂类型更新
    FACTORYTYPEHUIXIAN:api.Operate+"/model/getFactoryTypeById",//工厂类型-工厂类型的回显菜单

    //部门管理
    BRANCHADD:api.Operate+"/department/addUnit",                   //单位组--新增
    BRANCHLIST:api.Operate+"/department/getUnitList",              //单位组--列表
    BRANCHUPDATE:api.Operate+"/department/updateUnit",             //单位组--修改
    BRANCHDELETE:api.Operate+"/department/deleteUnit",             //单位组--删除   
    BRANCHSONLIST:api.Operate+"/department/getDepartmentByUnitId", //单位组对应的子部门--列表
    BRANCHSONADD:api.Operate+"/department/addDepart",              //单位组对应的子部门--新增
    BRANCHSONDELETE:api.Operate+"/department/deleteDepart",        //单位组对应的子部门--删除
    BRANCHSONEIDT:api.Operate+"/department/updateDepart",          //单位组对应的子部门--更新
    BRANCHSONSTADT:api.Operate+"/department/departable",           //单位组对应的子部门--启用禁用
    

    //角色管理 
    ROULELIST:api.Operate+"/role/getRolePage",            //角色管理-角色列表
    ROULEADD:api.Operate+"/role/add",                     //角色管理-新增角色
    ROULEUPDATE:api.Operate+"/role/update",               //角色管理-更新角色
    ROULEDELETE:api.Operate+"/role/delete",               //角色管理-删除角色
    ROULEEMENT:api.Operate+"/role/getRoleById",           //角色管理-获取角色的回显 

    // 充电商管理 
    GETCHARGERSPAGE:api.Operate+'/chargers/getChargersPage',    // 充电商管理 充电桩平台分页
    UPDATECHARGERS:api.Operate+'/chargers/updateChargers',      // 更新充电桩平台
    RESETPASSWORD:api.Operate+'/chargers/resetPassword',        // 重置密码
    ISENABLE:api.Operate+'/chargers/enable',                    // 禁用启用
    ADDCHARGERS:api.Operate+'/chargers/addChargers',            // 添加充电桩平台
    TRADELICENSE:api.httpUrl+'/minio-service/tradeLicense/uploadSingle',               // 营业执照
    GETPREVICEURL:'/minio-service/tradeLicense/getPreviewUrl',               // 浏览营业执照
}

//IOT平台
const IOTAPI= {
    FACILITYlIST:api.IOT+"/deviceTypeManage/getDeviceTypeList",       //设备分类-设备大类
    FACILITYADD:api.IOT+"/deviceTypeManage/addDeviceType",            //设备分类-新增设备大类及其小类 
    FACILITYEIDT:api.IOT+"/deviceTypeManage/updateDeviceType",        //设备分类-更新设备大类及其小类
    FACTLITYMINLIST:api.IOT+"/deviceTypeManage/getDeviceTypePage",    //设备分类-获取设备小类
    FACTLITYDELETE:api.IOT+"/deviceTypeManage/deleteDeviceType",      //设备分类-删除
    FACTLITYISOPEN:api.IOT+"/deviceTypeManage/enableDisable",         //设备分类-启用与禁用
    FACILITYICON:api.IOT+"/deviceTypeManage/getDeviceTypeBannerList", //设备分类-图标列表

    DEALLIST:api.IOT+"/protocolManage/getProtocolPage",             //协议管理-协议列表
    DEALADD:api.IOT+"/protocolManage/addProtocol",                  //协议管理-新增协议
    DEALFACTORY:api.Operate+"/factory/getFactoryListByFactoryName", //协议管理-新增协议的工厂
    DEALDELET:api.IOT+"/protocolManage/deleteProtocol",             //协议管理-删除协议管理
    DELETEISOPEN:api.IOT+"/protocolManage/enableDisable",           //协议管理-启用与禁用
    DELETEUPDATE:api.IOT+"/protocolManage/updateProtocol",          //协议管理-编辑协议
    DEVICELOG:'/service-logger/cmdRecord/selectV2',                 //日志管理
    CHARGELOG:'/service-logger/chargeLogger/select',// 充电桩日志
    COMPANYLIST:api.IOT+"/protocolManage/getProtocolCompanyList",   //公司列表
    
    ICONADD:api.IOT+"/deviceTypeManage/saveDeviceTypeBanner",           //新增设备类型的图标
    ICONUPDATA:api.IOT+"/deviceTypeManage/updateDeviceTypeBanner",      //修改设备类型的图标
    CMDLIST:api.Operate+"/deviceCmd/getDeviceCmdPage",                  //指令列表
    ADDCMD:api.Operate+"/deviceCmd/addOrUpdateDeviceCmd",               //新增及其编辑指令
    DELETECMD:api.Operate+"/deviceCmd/deleteDeviceCmd/",                //删除指令

    // 产品管理---iot---------------------------------------
    CREATECATEGORY:"/service-product/classify/createClassify",          // 分类新增
    UPDATECATEGORY:"/service-product/classify/updateClassifyByCid",      // 分类更新
    CREATEPRODUCT:"/service-product/product/createProduct",                             // 新增产品
    SELECTDTOBYCID:"/service-product/classify/selectChild",           // 根据分类查询产品
    SELECTSTANDARPRODUCT:'/service-product/product/selectProductPage',     // 查询所有标准设备
    UPDATEBYPRIMARYKEYPRODUCT:'/service-product/product/updateByPrimaryKey',                    // 更新设备
    CREATEPRODUCTATTR:'/service-product/productAttribute/createProductAttr',             // 增加产品属性
    SELECTPRODUCTATTR:'/service-product/productAttribute/selectProductAttr',            // 查询属性数据
    UPDATEBYPRIMARYKEY:'/service-product/productAttribute/updateByPrimaryKey',           // 更新属性
    UPDATECATEGORYPRODUCTBYID:'/service-product/classify/updateClassifyByCid',//  更新产品分类
    DELETEDTOCLASS:'/service-product/classify/delClassify',                    // 删除分类
    PUBLISHPRODUCT:'/service-product/product/publishProduct',                                   // 发布产品
    SETSTANDARD:'/service-product/classify/setStandard',                                        // 设置为标准模型
}

//充电桩平台
const ELECTAPI = {
    MARKINFO:api.Operate+"/label/getLabelTree",
    UPDATELABLE:api.Operate+'/label/updateLabel',
    ADDMARK:api.Operate+'/label/addLabel',
    DELETEMARK:api.Operate+"/label/deleteLabel"
}

//常用的正则表达式配置
const rules = {
    NONEMPTY:/^[\s\S]*.*[^\s][\s\S]*$/,                                                               //非空验证
    PHONE:/^1[3456789]\d{9}$/,                                                                        //手机号验证
    EMAIL:/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,                       //邮箱验证
    IDCARD:/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,    //身份证正则
    PASSWORD:/^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*?])\w{6,}$/,                          //密码的正则
    CHINESE:/^[\u4E00-\u9FA5]+$/,                                                                     //只允许输入中文 
    ENGCHEN:/^[A-Za-z0-9]+$/,                                                                         //只允许输入英文数字
    ENGCHENHSH:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/,                                        //匹配6~10位由数字和26个英文字母混合而成的密码
    ENGCHENUMBER:/^[A-Za-z0-9]{6,10}$/,                                                               //匹配6~10位由数字或者26个英文
    ENGCHENUMBEB:/^[A-Za-z0-9]{6,12}$/,                                                               //匹配6~12位由数字或者26个英文
    YINNOTESHU:/^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{6,10}$/,                  //必须包含数字、英文字母、特殊符号且大于等于8位（特殊符号包括: ~!@#$%^&*）
    YINNOTE:/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*]{6,18}$/,                                      //数字、英文字母、特殊符号可有可无，6-18位
    HTTPRULS:/^(http(s)?:\/\/)?([0-9a-z-]{1,}.)?[0-9a-z-]{2,}.([0-9a-z-]{2,}.)?[a-z]{2,}$/i,          //域名  https://www.itbulu.com 或者 http://itbulu.com
    HTTPRULB:/^(http(s)?:\/\/)?(www\.)?([0-9a-z-]{1,}.)?[0-9a-z-]{2,}.([0-9a-z-]{2,}.)?[a-z]{2,}$/i,  //域名  必须输入WWW
    HTTPRULC:/^([0-9a-z-]{1,}.)?[0-9a-z-]{2,}.([0-9a-z-]{2,}.)?[a-z]{2,}$/i,                          //域名  可以不用HTTPS/HTTP 
    POSITVIE:/^\d+$/,                                                                                 //大于等于0的正整数                                                                
}

//向外抛出
module.exports = {
    rules:rules,
    api:api,
    url:urlAddress,
    loginApi:LOGIN,
    operate:OPERATE,
    userApi:USERAPI,
    iotApi:IOTAPI,
    electapi:ELECTAPI
}